/* eslint-disable @typescript-eslint/no-non-null-assertion */
import CalendarIcon from '@mui/icons-material/CalendarMonth'
import { isPast } from 'date-fns/isPast'

import { ignoreTimezone, useDateFormatter } from '../../../../utils/date'
import { type Move, useSelectedQuote } from '../../../../modules/moves'
import TimeControl from '../TimeControl'

type DateAndTimeSectionProps = {
  move: Move
}

const DateAndTimeSection: React.FC<DateAndTimeSectionProps> = ({
  move,
}) => {
  const formatDate = useDateFormatter()
  const selectedQuote = useSelectedQuote()

  if (!selectedQuote?.jobs?.length) {
    return null
  }

  return (
    <div className="mb-6 flex flex-col gap-y-4">
      { selectedQuote.jobs.map((jobQuote, index) => {
        const isDatePast = isPast(ignoreTimezone(jobQuote.date)!)
        return (
          <div
            key={jobQuote.jobId}
            className="flex flex-col justify-between gap-y-2 sm:flex-row"
          >
            <div className="flex items-center gap-3 font-sans text-lg">
              <CalendarIcon className="!text-[18px] text-neutral-500" />
              <span>
                { formatDate(ignoreTimezone(jobQuote.date)) }
              </span>
            </div>

            <div className="flex items-center gap-3 font-sans text-xl">
              <TimeControl name={`selectedTime.${index}`} disabled={isDatePast} />
            </div>
          </div>
        )
      }) }
    </div>
  )
}

export default DateAndTimeSection
